module.exports = __webpack_public_path__ + "static/media/1.dbed2e2f.png";